import React from 'react'

import { InformationCard } from '@frame/ui-components/information-card'
import { UnorderedList } from '@frame/ui-components/unordered-list'
import { P } from '@frame/ui-primitives/p'
import { Span } from '@frame/ui-primitives/span'

export function OfferLetterInfo() {
  return (
    <InformationCard>
      <P className="text-sm">
        <Span className="font-bold">What is an offer letter? </Span>
        An offer letter is a written job offer from an employer. It explains your job title, salary, start date, and
        other important details about your employment.
      </P>
      <P className="text-sm">
        <Span className="font-bold">Important: </Span>
        The document must be the original offer letter provided by your employer as a PDF.
      </P>
      <UnorderedList
        className="text-sm"
        title="It includes:"
        items={[
          'Your name',
          'Job title',
          'Start date',
          'Salary or pay rate',
          'Work schedule',
          'Company name and contact details',
        ]}
      />
      <P className="text-sm">
        <Span className="font-bold">Where can I find mine? </Span>
        Ask your new employer, or, most likely, it's in your email inbox!
      </P>
    </InformationCard>
  )
}
